export function getExportableLineupsString(savedLineups) {
    const exportableLineups = savedLineups && savedLineups?.reduce((acc, curr) => {
        if (!acc[curr.exportableLineups]) {
            acc.push(curr?.exportableLineup);
        } else {
            acc.push(curr?.exportableLineup);
        }
        return acc;
    },[])

    return exportableLineups;
};